import {
  SET_AVAILABLE_HEADS,
  SET_IS_DISPATCHED_AVAILABLE_HEADS,
} from "@/store/mutations.type";
import { FETCH_AVAILABLE_HEADS } from "@/store/actions.type";
import { TARGET_SETTING_GET_HEADS } from "@/api/targetSettingsApi";
import JwtService from "@/common/jwt.service.js";

export const state = {
  isDispatchedHead: false,
  availableHeads: [],
};

export const actions = {
  async [FETCH_AVAILABLE_HEADS](context) {
    if (vm.$store.getters.isDispatchedHead === true) {
      return;
    }
    try {
      const data = await TARGET_SETTING_GET_HEADS();
      context.commit(SET_AVAILABLE_HEADS, data);
    } catch (e) {
      context.commit(SET_AVAILABLE_HEADS, []);
    } finally {
      context.commit(SET_IS_DISPATCHED_AVAILABLE_HEADS, true);
    }
  },
};

export const mutations = {
  [SET_AVAILABLE_HEADS](state, heads) {
    state.availableHeads = heads;
  },
  [SET_IS_DISPATCHED_AVAILABLE_HEADS](state, status) {
    state.isDispatchedHead = status;
  },
};

const getters = {
  isDispatchedHead(state) {
    return state.isDispatchedHead;
  },
  availableHeads(state) {
    if (!JwtService.isLogged()) return [];
    return state.availableHeads;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
